import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/globals.css'

// Add error handling for the root element
const rootElement = document.getElementById('root');
if (!rootElement) {
  document.body.innerHTML = `
    <div style="
      min-height: 100vh; 
      background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      color: white; 
      font-family: Inter, system-ui, sans-serif;
      text-align: center;
      padding: 20px;
    ">
      <div>
        <h1 style="font-size: 24px; margin-bottom: 16px;">Loading Error</h1>
        <p style="color: #cbd5e1; margin-bottom: 20px;">Could not find root element. Please refresh the page.</p>
        <button onclick="window.location.reload()" style="
          padding: 12px 24px; 
          background: #6366f1; 
          color: white; 
          border: none; 
          border-radius: 8px; 
          cursor: pointer;
          font-weight: 500;
        ">Reload Page</button>
      </div>
    </div>
  `;
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)